export const setThemeLight = () => ({
  type: 'SET_THEME_LIGHT',
});

export const setThemeDark = () => ({
  type: 'SET_THEME_DARK',
});

export const setPageThemeLight = () => ({
  type: 'SET_PAGE_THEME_LIGHT',
});

export const setPageThemeDark = () => ({
  type: 'SET_PAGE_THEME_DARK',
});

export const hamburgerOpen = () => ({
  type: 'HAMBURGER_OPEN',
});

export const hamburgerClose = () => ({
  type: 'HAMBURGER_CLOSE',
});
